module.exports = __webpack_public_path__ + "static/media/Articles_Hero_Desktop.1f790e87.png";